import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
  FormGroup,
  Badge,
} from "reactstrap";
import { Trans } from "react-i18next";

document.title = "Time Slot Det";

const AddTimeSlotDet = ({handleInput, akey, det, showSelected, removeTimeDet}) => {
  
  // Helper function to convert time string to minutes since midnight
  const timeToMinutes = (timeStr) => {
    if (!timeStr) return 0;
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours * 60 + minutes;
  };



  // Validate form before submission
  const validateForm = () => {
    if (!startTime || !endTime || !cutOffTime) {
      setErrorMsg("Start time, end time and cut off time are required");
      return false;
    }

    const startMinutes = timeToMinutes(startTime);
    const endMinutes = timeToMinutes(endTime);
    const cutOffMinutes = timeToMinutes(cutOffTime);
    const orderStartMinutes = orderStartTime ? timeToMinutes(orderStartTime) : null;

    if (startMinutes >= endMinutes) {
      setErrorMsg("Start time must be before end time");
      return false;
    }

    if (cutOffMinutes > endMinutes) {
      setErrorMsg("Cut off time must not be later than end time");
      return false;
    }

    if (orderStartTime && orderStartMinutes >= cutOffMinutes) {
      setErrorMsg("Order start time must be before cut off time");
      return false;
    }

    if (isNaN(expectedOrders) || expectedOrders < 0) {
      setErrorMsg("Expected orders must be a positive number");
      return false;
    }

    if (type === "regular" && recurringDays.length === 0) {
      setErrorMsg("Regular time slots must have at least one recurring day");
      return false;
    }

    if (type === "exceptional") {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      for (const range of dateRanges) {
        if (!range.startDate || !range.endDate) {
          setErrorMsg("All date ranges must have both start and end dates");
          return false;
        }

        const startDate = new Date(range.startDate);
        const endDate = new Date(range.endDate);

        if (startDate > endDate) {
          setErrorMsg("Start date must be before or equal to end date in date ranges");
          return false;
        }

        if (endDate < today) {
          setErrorMsg("Cannot create time slots for past dates");
          return false;
        }
      }
    }

    return true;
  };

  return (
    <React.Fragment>
        <div className="container-fluid" style={{backgroundColor:'silver', padding:'6px', margin:'6px'}}>
                    <Row>
                      {showSelected?(
                      <FormGroup className="col-md-1">
                        <Input
                          type="checkbox"
                          checked={det.selected==1}
                          onChange={e => handleInput(akey, e.target.checked,det.id)}
                          
                        />
                      </FormGroup>
                      ):<></>}
                      <FormGroup className="col-md-3">
                        <Label>
                          <Trans>Start Time</Trans>
                        </Label>
                        <Input
                          type="time"
                          value={det.timeFrom}
                          onChange={e => handleInput(akey, 'timeFrom',e.target.value)}
                          required
                        />
                      </FormGroup>

                      <FormGroup className="col-md-3">
                        <Label>
                          <Trans>End Time</Trans>
                        </Label>
                        <Input
                          type="time"
                          value={det.timeTo}
                          onChange={e => handleInput(akey, 'timeTo',e.target.value)}
                          required
                        />
                      </FormGroup>

                      <FormGroup className="col-md-2">
                        <Label>
                          <Trans>Order Start Time (Optional)</Trans>
                        </Label>
                        <Input
                          type="time"
                          value={det.prepareTimeFrom}
                          onChange={e => handleInput(akey, 'prepareTimeFrom',e.target.value)}
                        />
                      </FormGroup>

                      <FormGroup className="col-md-2">
                        <Label>
                          <Trans>Cut Off Time</Trans>
                        </Label>
                        <Input
                          type="time"
                          value={det.prepareTimeTo}
                          onChange={e => handleInput(akey, 'prepareTimeTo',e.target.value)}
                          required
                        />
                      </FormGroup>

                      <FormGroup className="col-md-3">
                        <Label>
                          <Trans>Expected Order Number</Trans>
                        </Label>
                        <Input
                          type="number"
                          value={det.maxVolume}
                          onChange={e => handleInput(akey, 'maxVolume',e.target.value)}
                          required
                        />
                      </FormGroup>
                      {!showSelected ? (
                      <div className=" col-md-12 mt-2">
                        <div className="mt-4">
                          <Button type="button" color="danger" onClick={()=>{removeTimeDet(akey)}}>
                            Remove
                          </Button>
                        </div>
                      </div>
                      ):<></>}
                    </Row>

        </div>
    </React.Fragment>
  )
};

export default AddTimeSlotDet;